import React, {useState, useMemo, useEffect, useCallback} from 'react';
import ReactFlagsSelect from "react-flags-select";
import {useTranslation} from "react-i18next";
import i18next from 'i18next';

const countryToLanguage = {
    MX: 'es',
    US: 'en',
    FR: 'fr',
    BR: 'pt',
    IT: 'it',
    CN: 'cn',
    RU: 'ru',
    IN: 'hi',
    DE: 'de',
    SA: 'ar'
};

const LanguageSelector = () => {
    const userLanguage = navigator.language.split("-")[0];
    let countryCode = Object.entries(countryToLanguage).find(([code, lang]) => lang === userLanguage)?.[0];
    countryCode = countryCode || 'MX';

    const cachedValue = useMemo(() => {
        return localStorage.getItem('languageKey') || countryCode;
    }, [countryCode]);

    const handleChange = useCallback((lng) => {
        if (!lng || lng === 'undefined') {
            return;
        }
        localStorage.setItem('languageKey', lng);
    }, []);

    const [selected, setSelected] = useState(cachedValue);
    const {t} = useTranslation();
    const handleLanguageChange = useCallback((lng) => {
        if (!lng || lng === 'undefined') {
            return;
        }
        const languageCode = countryToLanguage[lng];
        setSelected(lng)
        handleChange(lng)
        i18next.changeLanguage(languageCode).then(r => r);
    }, [handleChange]);

    useEffect(() => {
        // call your function here
        const setLanguage = async () => {
            handleLanguageChange(cachedValue);
        }

        setLanguage().then(r => r);
    }, [cachedValue, handleLanguageChange]);

    return (
        <ReactFlagsSelect
            selected={selected}
            //countries={["MX", "US", "FR", "BR", "IT", "UA", "RU"]}
            // customLabels={{
            //     MX: "Español",
            //     US: "English",
            //     FR: "Français",
            //     BR: "Português",
            //     IT: "Italiano",
            //     UA: "Українська",
            //     RU: "Русо"
            // }}
            countries={["MX", "US", "BR", "FR", "RU", "DE", "IT", "CN", "IN", "SA"]}
            customLabels={{
                MX: "Español",
                US: "English",
                BR: "Português",
                FR: "Français",
                RU: "Русо",
                DE: "Deutsch",
                IT: "Italiano",
                CN: "汉语",
                IN: "हिंदी",
                SA: "عربي"
            }}
            placeholder={t('language')}
            className="menu-flags"
            selectButtonClassName="menu-flags-button"
            style={{fontSize: '1.25em', color: 'black', border: '2px solid #4ec1ea'}}
            onSelect={(lng) => {
                handleLanguageChange(lng)
            }}
        />
    );
}


export default LanguageSelector;
